<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_317" data-name="Group 317" transform="translate(-315.731 -280.254)">
    <circle id="Ellipse_197" data-name="Ellipse 197" cx="35.201" cy="35.201" r="35.201" transform="translate(315.731 280.254)" fill="#fff"/>
    <path id="Path_318" data-name="Path 318" d="M2640.284,300.58h-5.434l-.324-1.259h0a2.377,2.377,0,0,0-2.35-1.79h-.022a2.376,2.376,0,0,0-2.339,1.827l-.293,1.222h-7.4v-2.366h-6.957v2.366h-7.548l-.324-1.259h0a2.379,2.379,0,0,0-2.35-1.79h-.022a2.376,2.376,0,0,0-2.339,1.827l-.293,1.222h-5.281v2.609h4.656l-4.249,17.73h15.434l-4.561-17.73h6.877v10.424h1.739V331.8h-10.7v2.609h24.877V331.8h-10.7V313.613h1.739V303.189h6.77l-4.249,17.73h15.435l-4.561-17.73h4.762Zm-8.285-.609h0Zm-27.228,0h0Zm4.718,18.339h-8.76l3.623-15.121h1.247Zm27.229,0h-8.761l3.623-15.121h1.247Z" transform="translate(-2267.717)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_02_01.vue